import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { auth } from './Firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './Firebase';
import { slugify } from '../utils/slugify'; 
import { useCompetitions } from './CompetitionContext';
import '../styles/NavigationMenu.css';

const NavigationMenu = () => {
  console.log('NavigationMenu rendered');
  const { competitions, loading } = useCompetitions();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      console.log('Auth state changed:', currentUser);
      if (currentUser && currentUser.emailVerified) {
        setUser(currentUser);
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          setUserName(userDoc.data().name || '');
        } else {
          setUserName('');
        }
      } else {
        setUser(null);
        setUserName('');
      }
    });
    return () => unsubscribe();
  }, []);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleLogout = async () => {
    await auth.signOut();
    setUser(null);
    setUserName('');
    navigate('/login');
  };

  const getAccountLabel = () => {
    return user && userName ? `Witaj, ${userName}!` : 'Zaloguj';
  };
  
  

  if (loading) return null; // Unikaj renderowania, dopóki dane się nie załadują

  return (
    <Box sx={{ backgroundColor: '#1a1a1a', padding: '10px 0', fontSize: '1.0rem'}}>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <IconButton onClick={handleMobileMenuToggle} sx={{ color: '#ffffff' }}>
          <MenuIcon />
        </IconButton>
      </Box>

      <Box sx={{ display: { xs: mobileMenuOpen ? 'block' : 'none', md: 'flex' }, justifyContent: 'center'}}>
        <ul className="nav-list">
          <li>
            <Link to="/" className="nav-link" >
              Strona główna
            </Link>
          </li>

          <li>
            <Menu
              menuButton={({ open }) => (
                <button
                  className="nav-link"
                  onMouseEnter={() => {
                    const menuButton = document.querySelector('#rozgrywki-menu-button');
                    if (menuButton) menuButton.click();
                  }}
                  id="rozgrywki-menu-button"
                >
                  Rozgrywki ▼
                </button>
              )}
              onMenuChange={({ open }) => {
                if (!open) {
                  const menuButton = document.querySelector('#rozgrywki-menu-button');
                  if (menuButton) menuButton.blur();
                }
              }}
              transition
              menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
              align="center"
              direction="bottom"
              offsetY={5}
            >
				{/* 🔥 NOWA STAŁA POZYCJA NA GÓRZE */}
			  <MenuItem>
				<Link
				  to="/liga/431/mistrzostwa-swiata"
				  style={{
					color: '#ffd700',
					textDecoration: 'none',
					width: '100%',
					fontWeight: 700
				  }}
				>
				  Mistrzostwa Świata
				</Link>
			  </MenuItem>
              {/* Liga Polska (poziomy 1-4) */}
              {Object.keys(competitions || {})
                .filter((level) => parseInt(level) >= 1 && parseInt(level) <= 4)
                .sort((a, b) => a - b)
                .map((level) => {
                  const comps = competitions[level].filter((comp) => comp.country === 'Poland');
                  const latestComps = comps.filter((comp) => comp.season === '2025/26');

                  if (latestComps.length === 0) return null;

                  const hasGroups = latestComps.some((comp) => comp.group && comp.group !== ' ');
                  if (hasGroups) {
                    return (
                      <SubMenu
                        key={level}
                        label={latestComps[0].name}
                        menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
                        offsetX={5}
                      >
                        {latestComps
                          .sort((a, b) => a.group.localeCompare(b.group))
                          .map((comp) => {
                            const leagueDisplay = comp.group && comp.group !== 'Brak' && comp.group.trim() !== ''
                              ? `${comp.name} (${comp.group})`
                              : comp.name;
                            return (
                              <MenuItem key={comp.competition_id}>
                                <Link
                                  to={`/liga/${comp.competition_id}/${slugify(leagueDisplay)}`}
                                  style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}
                                >
                                  {comp.group.charAt(0).toUpperCase() + comp.group.slice(1)}
                                </Link>
                              </MenuItem>
                            );
                          })}
                      </SubMenu>
                    );
                  } else {
                    return latestComps.map((comp) => {
                      const leagueDisplay = comp.group && comp.group !== 'Brak' && comp.group.trim() !== ''
                        ? `${comp.name} (${comp.group})`
                        : comp.name;
                      return (
                        <MenuItem key={comp.competition_id}>
                          <Link
                            to={`/liga/${comp.competition_id}/${slugify(leagueDisplay)}`}
                            style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}
                          >
                            {comp.name}
                          </Link>
                        </MenuItem>
                      );
                    });
                  }
                })}

              {/* Regionalne (Polska, level > 4) */}
              <SubMenu
                label="Regionalne"
                menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
                offsetX={5}
              >
                {Object.keys(competitions || {})
                  .filter((level) => parseInt(level) > 4)
                  .flatMap((level) =>
                    competitions[level]
                      .filter((comp) => comp.season === '2025/26' && comp.country === 'Poland')
                      .map((comp) => comp.region_id)
                  )
                  .filter((regionId, index, self) => self.indexOf(regionId) === index) // Unikalne region_id
                  .map((regionId) => {
                    const regionalComps = Object.values(competitions)
                      .flat()
                      .filter(
                        (comp) =>
                          comp.season === '2025/26' &&
                          comp.region_id === regionId &&
                          comp.country === 'Poland' &&
                          parseInt(Object.keys(competitions).find((l) => competitions[l].includes(comp))) > 4
                      )
                      .sort((a, b) => {
                        if (a.level !== b.level) return a.level - b.level; // Sortuj po level rosnąco
                        return a.group.localeCompare(b.group); // Następnie po group
                      });

                    if (regionalComps.length === 0) return null;

                    return (
                      <SubMenu
                        key={regionId}
                        label={regionalComps[0]?.region || `Region ${regionId}`}
                        menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
                        offsetX={5}
                      >
                        {regionalComps.map((comp) => {
                          const leagueDisplay = comp.group && comp.group !== 'Brak' && comp.group.trim() !== ''
                            ? `${comp.name} (${comp.group})`
                            : comp.name;
                          return (
                            <MenuItem key={comp.competition_id}>
                              <Link
                                to={`/liga/${comp.competition_id}/${slugify(leagueDisplay)}`}
                                style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}
                              >
                                {comp.name} ({comp.group})
                              </Link>
                            </MenuItem>
                          );
                        })}
                      </SubMenu>
                    );
                  })}
              </SubMenu>
			  
			  {/* Europejskie Puchary 
              <SubMenu
				  label="Europejskie Puchary"
				  menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
				  offsetX={5}
				>
				  {Object.values(competitions || {})
					.flat()
					.filter((comp) => comp.season === '2025/26' && comp.country === 'European Cups')
					.sort((a, b) => a.competition_id - b.competition_id)
					.map((comp) => (
					  <MenuItem key={comp.competition_id}>
						<Link
						  to={`/liga/${comp.competition_id}`}
						  style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}
						>
						  {comp.name} - {comp.group}
						</Link>
					  </MenuItem>
					))}
				</SubMenu>

              <SubMenu
                label="Eliminacje MŚ"
                menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
                offsetX={5}
              >
                {Object.values(competitions || {})
                  .flat()
                  .filter((comp) => comp.season === '2025/26' && comp.country === 'International')
                  .sort((a, b) => a.group.localeCompare(b.group))
                  .map((comp) => (
                    <MenuItem key={comp.competition_id}>
                      <Link
                        to={`/liga/${comp.competition_id}`}
                        style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}
                      >
                        {comp.group.charAt(0).toUpperCase() + comp.group.slice(1)}
                      </Link>
                    </MenuItem>
                  ))}
              </SubMenu>*/}
            </Menu>
          </li>

          {/* Menu "Inne" - rozwijane */}
          <li>
            <Menu
              menuButton={({ open }) => (
                <button
                  className="nav-link"
                  onMouseEnter={() => {
                    const menuButton = document.querySelector('#inne-menu-button');
                    if (menuButton) menuButton.click();
                  }}
                  id="inne-menu-button"
                >
                  Inne ▼
                </button>
              )}
              onMenuChange={({ open }) => {
                if (!open) {
                  const menuButton = document.querySelector('#inne-menu-button');
                  if (menuButton) menuButton.blur();
                }
              }}
              transition
              menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
              align="center"
              direction="bottom"
              offsetY={5}
            >
              <MenuItem>
                <Link to="/elo-ranking" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                  Ranking Elo
                </Link>
              </MenuItem>
			  <MenuItem>
                <Link to="/achievements-list" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                  Wybryki statystyczne
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/blog/jak-tworzone-sa-symulacje" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                  Jak działają symulacje?
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/blog/faq-najczesciej-zadawane-pytania" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                  FAQ
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/blog" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                  Artykuły
                </Link>
              </MenuItem>
            </Menu>
          </li>

          <li>
            <Menu
              menuButton={({ open }) => (
                <button
                  className="nav-link"
                  onMouseEnter={() => {
                    const menuButton = document.querySelector('#konto-menu-button');
                    if (menuButton) menuButton.click();
                  }}
                  id="konto-menu-button"
                >
                  {getAccountLabel()} ▼
                </button>
              )}
              onMenuChange={({ open }) => {
                if (!open) {
                  const menuButton = document.querySelector('#konto-menu-button');
                  if (menuButton) menuButton.blur();
                }
              }}
              transition
              menuStyle={{ backgroundColor: '#2c2c2c', color: '#ffffff', minWidth: '200px' }}
              align="center"
              direction="bottom"
              offsetY={5}
            >
              {user ? (
                <>
                  <MenuItem>
                    <Typography sx={{ color: '#ffffff', p: 1 }}>
                      Witaj, {userName} <span style={{ color: '#4caf50' }}>●</span>
                    </Typography>
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    <Typography sx={{ color: '#ffffff', p: 1 }}>Wyloguj</Typography>
                  </MenuItem>
                </>
              ) : (
                <>
                  <MenuItem>
                    <Link to="/login" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                      Logowanie
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to="/register" style={{ color: '#ffffff', textDecoration: 'none', width: '100%' }}>
                      Rejestracja
                    </Link>
                  </MenuItem>
                </>
              )}
            </Menu>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default NavigationMenu;